import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UnsignedUploadDocumentState } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/store/reducers/unsigned-upload-document.reducer';
import { unsignedUploadDocumentStoreKey } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/store/store-config';

export const selectUnsignedUploadDocumentFeature = createFeatureSelector<UnsignedUploadDocumentState>(unsignedUploadDocumentStoreKey);

export const selectUnsignedUploadDocuments = createSelector(
    selectUnsignedUploadDocumentFeature,
    (state) => state?.documents
);


